module.exports = {
    fullpageLicenseKey: process.env.FULLPAGEJS_LICENSE,
    contentfulAccessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
    contentfulSpaceID: process.env.CONTENTFUL_SPACEID,
};
